import React from 'react';
import { ToastContainer } from 'react-toastify';

const CustomToastContainer = () => {
    const toastContainerProps = {
        position: 'top-right',
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        theme: 'colored',
        style: {
            color: '#fff',
            fontSize: '16px',
            zIndex: 10000,
        },
    } as const;

    return <ToastContainer {...toastContainerProps} />;
};

export default CustomToastContainer;
